import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from 'src/app/core/services/validation.service';
import { MatDialog } from '@angular/material/dialog';
import { ClaimTicketVerificationComponent } from '../claim-ticket-verification/claim-ticket-verification.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CONST_AWS_API, API } from '../../../../../core/constants';
import { API as AWS_API } from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/core/services/app.service';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { UserService } from 'src/app/core/services/user.service';
import { StorageService } from 'src/app/core/services/storage.service';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

@Component({
  selector: 'app-claim-ticket',
  templateUrl: './claim-ticket.component.html',
  styleUrls: ['./claim-ticket.component.scss']
})
export class ClaimTicketComponent implements OnInit {

  contactDetail: FormGroup;
  ticket_key = "";
  ticket_ids: any = [];
  tickets: any = [];
  event_id = "";
  organization_id: any;
  visibleView = "contactDetail";
  questionsList: any = [];
  currentLocation: any = {};
  getCurrentCurrency: any = "GBP";
  ticketsData: any = [];
  user_id = "";
  isLiveTicket: any;
  getUserData: any;
  device:any;
  timezoneVal:any;
  assets_url = environment.assets_url;
  clientDetails: any;
  constructor(private _formBuilder: FormBuilder, private ngxLoader: NgxUiLoaderService,
    private toastr: ToastrService, private _matDialog: MatDialog, public router: Router,
    private appService: AppService, private commonSubscribeService: CommanSubscribeService,
    public activatedRoute: ActivatedRoute,private userService: UserService,
    private storageService: StorageService) { }

  get channelName(): string {
    return this.activatedRoute.snapshot.params['channelName'] || '';
  }

  ngOnInit() {
    this.clientDetails = environment.clientDetails;
    this.timezoneVal = this.userService.getTimezone();
    this.buildForm();
    if (this.activatedRoute.snapshot.params.ticket_key) {
      this.event_id = this.activatedRoute.snapshot.params.ticket_key.split("-")[0] || "";
      this.user_id = this.activatedRoute.snapshot.params.ticket_key.split("-")[1] || "";
      this.ticket_key = this.activatedRoute.snapshot.params.ticket_key;
      this.getTicket();
    } else {
      this.toastr.error("Invalid url");
      this.router.navigateByUrl('/' + this.channelName);
    }
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
          this.getCurrentCurrency = this.currentLocation.currency.code;
        }
      });
    } else if(this.currentLocation && Object.keys(this.currentLocation).length > 0){
      this.getCurrentCurrency = this.currentLocation.currency.code;
    }
    this.device = this.commonSubscribeService.getMobileOperatingSystem(); 
  }

  buildForm() {
    this.contactDetail = this._formBuilder.group({
      firstName: [this.getUserData ? this.getUserData.first_name:'', Validators.required],
      lastName: [this.getUserData ?this.getUserData.last_name:'', Validators.required],
      email: [this.getUserData ?this.getUserData.email:'', [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
    });
  }

  getTicket() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        ticket_key: this.ticket_key,
        "timezone": this.timezoneVal
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_TICKET, data).then(response => {
      this.ngxLoader.stop();
      if (response.data.message == "success") {
        let streamInfo = response.data.stream_info.stream_info;
        if (streamInfo.age_limit <= 15) {
          streamInfo.ageInfo = 'Family Friendly';
        } else if (streamInfo.age_limit == 16 || streamInfo.age_limit <= 17) {
          streamInfo.ageInfo = 'Adults Supervision';
        } else if (streamInfo.age_limit == 18 || streamInfo.age_limit <= 20) {
          streamInfo.ageInfo = '18+';
        }
        else if (streamInfo.age_limit == 21 || streamInfo.age_limit > 21) {
          streamInfo.ageInfo = '21+';
        }
        streamInfo.originalPublishDate = streamInfo.publish_date_time;
        streamInfo.originalExpectedDate = streamInfo.expected_end_date_time;
        this.commonSubscribeService.sendStreamInfo(streamInfo);
        this.organization_id = streamInfo.organization_id;
        this.commonSubscribeService.sendSubEventsInfo(response.data.stream_info.subEvents);
        this.ticket_ids = response.data.ticket_ids || [];
        this.isLiveTicket = response.data.live;
        if(response.data.user){
          if(response.data.user.id != this.user_id){
            this.getUserData = response.data.user;
            this.buildForm();
          }
        }
        this.getTicketsData(this.user_id, response.data.live);
      } else if (response.data.status == 1) {
        this.toastr.error(response.data.message);
        this.router.navigateByUrl('/' + this.channelName);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }


  verifyEmail() {
    if (this.contactDetail.valid) {
      let rawData = this.contactDetail.getRawValue();
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key
        },
        response: true,
        body: {
          name: rawData.firstName + " " + rawData.lastName,
          email: rawData.email,
          ticket_key: this.ticket_key,
          event_id: this.event_id,
          ticket_id: this.ticket_ids[0]
        }
      }
      this.ngxLoader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.VERIFY_EMAIL, data).then(response => {
        this.ngxLoader.stop();
        if (response.data.status == 0) {
          if (response.data.sent_otp == "no") {
            this.getQuestionsByEventId();
          } else if (response.data.sent_otp == "yes") {
            this.toastr.success("Verification code sent to the " + rawData.email);
            this.openVerificationCode();
          }
        } else {
          this.toastr.error(response.data.message);
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    }
  }

  openVerificationCode() {
    const dialogRef = this._matDialog.open(ClaimTicketVerificationComponent, {
      maxWidth: "320px",
      panelClass: "app-claim-ticket-verification",
      disableClose: false,
      data: {
        formdata: this.contactDetail.getRawValue(),
        ticket_key: this.ticket_key
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.close == "yes") {
        this.verified_otp = result.verified_otp;
        this.getQuestionsByEventId();
      }
    });
  }

  questionsListNew: any;
  getQuestionsByEventId() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {}
    }
    this.ngxLoader.start();
    let url = CONST_AWS_API.GET_QUESTIONS_BY_EVENT_ID + '/' + this.event_id;
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      this.ngxLoader.stop();
      if (response.status == 200) {
        let list = response['data']['Data'];
        if (list && list.length > 0) {
          list.forEach(element => {
            if (element.options) {
              element.options = JSON.parse(element.options);
            }

            if (element.option_type == "checkbox") {
              element.options = element.options || [];
              element.options.forEach(e1 => {
                e1.value = false;
              });
            }
            if (element.question_type == "general") {
              this.questionsList.push(element);
            }
            if (this.ticket_ids.includes(Number(element.ticket_id))) {
              this.tickets.forEach(ticket => {
                if (this.ticket_ids.includes(Number(element.ticket_id)) && Number(element.ticket_id) == ticket.id) {
                  element.ticket_name = ticket.name;
                  element.question_type = ticket.name;
                }
              });
              this.questionsList.push(element);
            }
            const grouped = this.questionsList.reduce((groups, stage) => {
              const pos = stage.question_type;
              groups[pos] = groups[pos] || [];
              groups[pos].push(stage);

              return groups;
            }, {});
            this.questionsListNew = Object.keys(grouped).map(key => ({ type: key, userQuestions: grouped[key] }));
          });
        }
        if (this.questionsList && this.questionsList.length > 0) {
          this.visibleView = "questionList";
        } else {
          if (this.isLiveTicket)
            this.saveQuestionsData();
          else
            this.claimTicket();
        }
      }
    }, error => {
      console.log(error);
    })
  }

  questionid_byans = {};
  quesAns: any = [];
  saveQuestions(valid) {

    this.questionid_byans = {};
    this.quesAns = [];

    if (valid) {

      let isCheckedChecked = true;

      this.questionsListNew.forEach(e => {
        e.userQuestions.forEach(qtn => {


          if (qtn.option_type == "checkbox") {
            let selectedCheck = qtn.options.filter(a => a.value == true);
            if (qtn.is_mandatory == 1 && (!selectedCheck || selectedCheck.length == 0) && isCheckedChecked) {
              isCheckedChecked = false;
            }

            if (selectedCheck && selectedCheck.length != 0) {
              qtn.value = qtn.options.filter(op => op.value == true).map(op => op.option).toString();
              qtn.valueArray = qtn.options.filter(op => op.value == true).map(op => op.option);
            }
          } else {
            qtn.valueArray = [qtn.value];
          }

          this.questionid_byans[qtn.id] = qtn.value || '';
          if (qtn.value) {
            this.quesAns.push({
              'id': qtn.id,
              'ques': qtn.question,
              'ans': qtn.valueArray
            })
          }
          console.log(this.quesAns);
        });
      });
      if (!isCheckedChecked) {
        this.toastr.error('Please answer all mandatory questions');
        return;
      }
      if (this.isLiveTicket)
        this.saveQuestionsData();
      else
        this.claimTicket();
    } else {
      this.toastr.error('Please answer all mandatory questions');
    }
  }

  saveQuestionsData() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        ticket_key: this.activatedRoute.snapshot.params.ticket_key,
        questions: this.quesAns
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.SAVE_QUESTIONS, data).then(response => {
      this.ngxLoader.stop();
      if (response.data.status == 0) {
        this.router.navigateByUrl('/' + this.channelName);
      } else {
        this.toastr.error(response.data.message);
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }


  verified_otp = "";
  addOnCheck:boolean= false;
  showScheduleBtn: boolean = false;
  key:any;
  scheduleUrl:any;
  claimTicket() {
    let rawData = this.contactDetail.getRawValue();
    let email_data = {
      "firstname": rawData.firstName,
      "lastname": rawData.lastName,
      "email": rawData.email.toLowerCase(),
      "stream_id": this.event_id,
      "organization_id": this.organization_id
    };
    this.appService.postRequest(API.GET_USER_BY_EMAIL, email_data).subscribe(result => {
      if (result.status == 0) {

        this.getTicketsByTicketId(result.user.id, (callBack: any) => {
          let questions = [];
          if (this.quesAns.length > 0) {
            questions.push({
              questions: this.quesAns, 
            });
          }
          let data = {
            headers: {
              "Content-Type": "application/json",
              "x-api-key": environment.AWS_Cognito.X_Api_Key
            },
            response: true,
            body: {
              ticket_key: this.ticket_key,
              otp: this.verified_otp || 0,
              name: rawData.firstName + " " + rawData.lastName,
              email: rawData.email,
              user_id: result.user.id,
              sessions: this.ticket_ids,
              questions: this.quesAns,
              ticket_ids: this.ticket_ids,
              tickets: this.tickets
            }
          }
          this.ngxLoader.start();
          AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.CLAIM_TICKET, data).then(response => {
            this.ngxLoader.stop();
            if (response.data.status == 0) {
              let ticketInfo;
              this.ticketsData.forEach(element => {
                if (this.ticket_ids.includes(element.id)) {
                  ticketInfo = element;
                  if(element.add_ons)
                    this.addOnCheck = true;
                }
              });
              if(this.addOnCheck){
                this.router.navigateByUrl('/' + this.channelName);
                return;
              } else {
                this.showScheduleBtn = true;
              }
              this.key = response.data.ticket_key;
              this.scheduleUrl = environment.CONSUMER_PORTAL + `${this.channelName}/event/schedule/` + this.key;
              // if (ticketInfo.expo && ticketInfo.sessions.length == 0)
              //   this.router.navigate(['event/expo-list/' + response.data.ticket_key]);
              // else
              //   this.router.navigate(['event/schedule/' + response.data.ticket_key]);
            } else {
              this.toastr.error(response.data.message);
            }
          }).catch(error => {
            this.ngxLoader.stop();
          });
        });
      }
    }, error => {

    });

  }

  getTicketsByTicketId(user_id, callback: (val: any) => void) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        id: this.event_id
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_TICKETS, data).then(response => {
      this.ngxLoader.stop();
      if (response.status == 200) {
        this.ticketsData = response['data']['Data'] || [];
        this.tickets = [];
        this.ticketsData.forEach(element => {
          this.tickets.push({
            'id': element.id, 'limited_tickets': element.limited_tickets, name: element.title
          });
        });
      }
      callback(true);
    }, error => {
      console.log(error);
      callback(false);
    })
  }

  getTicketsData(user_id, live) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        id: this.event_id
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_TICKETS, data).then(response => {
      this.ngxLoader.stop();
      if (response.status == 200) {
        this.ticketsData = response['data']['Data'] || [];
        this.tickets = [];
        this.ticketsData.forEach(element => {
          this.tickets.push({
            'id': element.id, 'limited_tickets': element.limited_tickets, name: element.title
          });
        });
        if (live)
          this.getQuestionsByEventId();
      }
    }, error => {
      console.log(error);
    })
  }

  redirectTo(){
    this.router.navigate([`${this.channelName}/event/schedule/` + this.key]);
  }

}
